<template>
  <div class="table-page-search-wrapper" id="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="48" class="searchRow">
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="请输入档案件" v-model="searchModel.assetNumber" />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="请输入编号" v-model="searchModel.txt50" />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="请输入密级" v-model="searchModel.ndjar" />
          </a-col>
          <a-col :md="12" :sm="24" class="searchColBtn">
            <span class="table-page-search-submitButtons">
              <a-button class="btn" type="primary" @click="search">查询</a-button>
              <a-button class="btn btnMarginLeft_12" @click="clearSearch">重置</a-button>
              <span class="btnMarginLeft_12 unfoldText" @click="toggleAdvanced">
                <span v-if="advanced">收缩</span>
                <span v-else>展开</span>
                <span v-if="advanced" unselectable="on" class="ant-select-open ant-select-focused ant-select-arrow unfoldIcon" style="user-select: none;"><i aria-label="图标: down" class="anticon anticon-down ant-select-arrow-icon"><svg
                  viewBox="64 64 896 896"
                  data-icon="down"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  focusable="false"
                  class=""><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path></svg></i></span>
                <span v-else unselectable="on" class="ant-select-arrow unfoldIcon" style="user-select: none;"><i aria-label="图标: down" class="anticon anticon-down ant-select-arrow-icon"><svg
                  viewBox="64 64 896 896"
                  data-icon="down"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  focusable="false"
                  class=""><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path></svg></i></span>
              </span>
            </span>
          </a-col>
        </a-row>
        <a-row :gutter="48" class="searchRow" style="margin-bottom: 10px !important;">
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-date-picker
              :showToday="false"
              format="YYYY-MM-DD"
              placeholder="资本化日期"
              v-model="searchModel.aktiv"
            />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-date-picker
              :showToday="false"
              format="YYYY-MM-DD"
              placeholder="首次购置日期"
              v-model="searchModel.zugdt"
            />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-date-picker
              :showToday="false"
              format="YYYY-MM-DD"
              placeholder="不活动日期"
              v-model="searchModel.deakt"
            />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-select
              :allowClear="true"
              v-model="searchModel.ord42"
              showSearch
              :filterOption="filterOption"
              placeholder="增加方式"
            >
              <a-select-option v-for="(item, index) in addTypeList" :value="item.code" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :md="4" :sm="24" class="searchColSelect">
            <a-input placeholder="资产数量" v-model="searchModel.menge" />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColSelect">
            <a-select
              :allowClear="true"
              v-model="searchModel.ord41"
              showSearch
              :filterOption="filterOption"
              placeholder="使用状态"
            >
              <a-select-option v-for="(item, index) in useTypeList" :value="item.code" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row :gutter="48" class="searchRow" style="margin-bottom: 10px !important;">
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="责任人" v-model="searchModel.raumn" />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="采购关联订单" v-model="searchModel.ebeln" />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input-group compact style="width: 100%">
              <a-input v-model="searchModel.kansw" style=" width: calc(50% - 15px); text-align: center" placeholder="购置价值" />
              <a-input
                style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                placeholder="~"
                disabled
              />
              <a-input v-model="searchModel.kanswEnd" style="width: calc(50% - 15px); text-align: center; border-left: 0" placeholder="购置价值" />
            </a-input-group>
          </a-col>
          <a-col :md="4" :sm="24" class="searchColSelect">
            <a-input-group compact style="width: 100%">
              <a-input v-model="searchModel.qmjz" type="number" style=" width: calc(50% - 15px); text-align: center" placeholder="现值" />
              <a-input
                style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                placeholder="~"
                disabled
              />
              <a-input v-model="searchModel.qmjzEnd" type="number" style="width: calc(50% - 15px); text-align: center; border-left: 0" placeholder="现值" />
            </a-input-group>
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-tree-select
              v-model="searchModel.aaa"
              style="width: 100%"
              placeholder="使用部门"
              allow-clear
              show-search
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :treeData="useDepartmentsList"
              treeNodeFilterProp="title"
              :replaceFields="{
                title: 'url',
                key: 'key',
                value: 'key'
              }"
            ></a-tree-select>
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-select
              :allowClear="true"
              v-model="searchModel.ord43"
              showSearch
              :filterOption="filterOption"
              placeholder="归口部门"
            >
              <a-select-option v-for="(item, index) in focalDepartmentsList" :value="item.code" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>
import processIcon from '@/views/assetLedger/modules/processIcon'
import { assetTypeList, getDeptTreeListInSearch, getSelectDataList, getTreeByRoleUsedeptList } from '@/api/assetLedger'
import processDropDown from '@/components/ProcessDropDown/ProcessDropDown'
import { mapGetters } from 'vuex'

export default {
  name: 'SearchForm',
  components: {
    processDropDown,
    processIcon
  },
  computed: {
    ...mapGetters(['fileManagementCompanyId'])
  },
  watch: {
    fileManagementCompanyId (newValue) {
      if (newValue.id !== '') {
        if (newValue.id === '空' || newValue.id === '杭氧') {
          if (newValue.id === '杭氧') {
            this.companyId = null
          }
          this.useDepartmentsList = []
        } else {
          this.companyId = newValue.id
        }
      } else {
        this.companyId = null
      }
      if (newValue.id !== '空') {
        this.getUseDepartmentsList()
      }
    }
  },
  data () {
    return {
      showExpend: false,
      searchModel: {},
      popoverStyle: {
        mixWidth: '0px',
        width: '100px'
      },
      processList: ['资产盘点', '领用申请', '调拨申请', '归还申请', '报废申请', '维修申请'],
      advanced: false, // 是否展开
      // 资产状态下拉列表
      assetTypeList: [],
      // 增加方式
      addTypeList: [],
      // 使用方式
      useTypeList: [],
      // 使用方式
      useDepartmentsList: [],
      // 归口部门
      focalDepartmentsList: [],
      roleList: [],
      // 是否显示发起流程
      visible: false,
      companyId: null
    }
  },
  created () {
    // 获取资产状态
    this.getAssetTypeList()
    // 获取增加方式，使用状态，归口部门下拉数据
    this.getSelectDataList()
    // 获取使用部门
    // this.getUseDepartmentsList()
  },
  mounted () {
  },
  methods: {
    // 获取资产状态
    getAssetTypeList () {
      assetTypeList().then(res => {
        if (res.status === 0) {
          this.assetTypeList = res.data
        }
      })
    },
    // 获取使用部门
    getUseDepartmentsList () {
      const data = {
        paging: false,
        isAsset: true
      }
      if (this.companyId) {
        data.companyId = this.companyId
      }
      getTreeByRoleUsedeptList(data).then(res => {
        if (res.status === 0) {
          this.useDepartmentsList = res.data
        }
      })
    },
    // 获取增加方式，使用状态，归口部门下拉数据
    getSelectDataList () {
      getSelectDataList().then(res => {
        if (res.status === 0) {
          this.addTypeList = res.data.tjfsList
          this.useTypeList = res.data.syztList
          this.focalDepartmentsList = res.data.gkbmList
        }
      })
    },
    // 搜索框展开
    toggleAdvanced () {
      const dom = document.getElementById('table-page-search-wrapper')
      console.log(dom)
      if (this.advanced) {
        this.$emit('saveAdvanced', false)
        dom.classList.remove('unfold')
        this.$emit('changeScrollY', 50, 'subtract')
        this.advanced = false
      } else {
        this.$emit('saveAdvanced', true)
        dom.classList.add('unfold')
        this.$emit('changeScrollY', 138, 'addAssetTableHeigth')
        this.advanced = true
      }
    },
    // 点击发起流程
    initiateTheProcess (name) {
      console.log(name)
    },
    // 点击查询按钮
    search () {
      if (this.searchModel.kansw === '') {
        this.searchModel.kansw = undefined
      }
      if (this.searchModel.kanswEnd === '') {
        this.searchModel.kanswEnd = undefined
      }
      if (this.searchModel.qmjz === '') {
        this.searchModel.qmjz = undefined
      }
      if (this.searchModel.qmjzEnd === '') {
        this.searchModel.qmjzEnd = undefined
      }
      if (Number(this.searchModel.kansw) > Number(this.searchModel.kanswEnd)) {
        const num = this.searchModel.kansw
        this.searchModel.kansw = this.searchModel.kanswEnd
        this.searchModel.kanswEnd = num
      }
      if (Number(this.searchModel.qmjz) > Number(this.searchModel.qmjzEnd)) {
        const num = this.searchModel.qmjz
        this.searchModel.qmjz = this.searchModel.qmjzEnd
        this.searchModel.qmjzEnd = num
      }
      const model = { ...this.searchModel }
      // 资产编号
      if (model.assetNumber) {
        model.assetNumber = model.assetNumber.trim()
      }
      // 资产描述
      if (model.txt50) {
        model.txt50 = model.txt50.trim()
      }
      // 资产使用年限
      if (model.ndjar) {
        model.ndjar = model.ndjar.trim()
      }
      // 资产数量
      if (model.menge) {
        model.menge = model.menge.trim()
      }
      // 责任人
      if (model.raumn) {
        model.raumn = model.raumn.trim()
      }
      // 采购关联订单
      if (model.ebeln) {
        model.ebeln = model.ebeln.trim()
      }
      // 购置价值
      if (model.kansw) {
        model.kansw = model.kansw.trim()
      }
      if (model.kanswEnd) {
        model.kanswEnd = model.kanswEnd.trim()
      }
      // 现值
      if (model.qmjz) {
        model.qmjz = model.qmjz.trim()
      }
      if (model.qmjzEnd) {
        model.qmjzEnd = model.qmjzEnd.trim()
      }
      // 资本化日期
      if (model.aktiv) {
        model.aktiv = model.aktiv.format('YYYY-MM-DD 00:00:00')
      }
      // 首次购置日期
      if (model.zugdt) {
        model.zugdt = model.zugdt.format('YYYY-MM-DD 00:00:00')
      }
      // 不活动日期
      if (model.deakt) {
        model.deakt = model.deakt.format('YYYY-MM-DD 00:00:00')
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      this.$emit('setSearchCondition', model)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {}
      this.$emit('clearSearch', this.searchModel)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  height: 42px;
  overflow: hidden;
  transition: height 300ms ease;
}
.unfold{
  height: 126px;
  //margin-bottom: 10px;
}
.searchRow {
  margin: 0 !important;
  .ant-calendar-picker {
    width: 100%;
  }
}
.searchColInput {
  padding: 0 12px 0 0 !important;
}
.searchColSelect {
  padding: 0 12px 0 0 !important;
}
.searchColBtn {
  padding: 0 !important;
  .table-page-search-submitButtons {
    margin-bottom: 10px !important;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
.btn {
  padding: 0 10px !important;
}
.btnMarginLeft_12 {
  margin-left: 10px !important;
}
.unfoldText {
  color: #1791FF;
  position: relative;
  cursor: pointer;
  width: 48px;
  display: inline-block;
}
.unfoldIcon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 3px;
  right: 4px;
  margin: auto;
  color: #1791FF;
  font-size: 12px;
  line-height: 1;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
}
/deep/.ant-popover-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.process {
  display: flex;
  flex-direction: column;
  align-items: center;
  a {
    line-height: 15px;
  }
  .marignBottom_12 {
    margin-bottom: 12px;
  }
}
</style>
